import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'did_the_fac_consult_w_worker_representatives_andor_trade_union'

export const dataPointDefinition = {
  retracedId: 'did_the_fac_consult_w_worker_representatives_andor_trade_union',
  name: 'Did the facility consult with worker representatives and/or trade union representatives to develop alternatives to suspension or reduction in workforce that was due to economic, technological, structural, operational or other similar changes?',
  description:
    'The intent of this question is to understand if the facility met with representatives to discuss alternatives to suspension or reduction (mass layoffs) in workforce. \r\r\n\r\r\nFor example, worker representatives and/or trade union representatives might discuss facility hiring freezes or working time reductions with facility management.\r\r\n\r\r\nIf there is no example of a mass layoff, i.e. there have been no layoffs in the last months within this assessment period, the response would be "Not Applicable".',
  meta: {},
  fieldTypeId: 'SELECT',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'ynna',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'ynna',
    },
    {
      name: 'Not Applicable',
      key: 'NOT_APPLICABLE',
      slcpIndex: 3,
      slcpOptionName: 'ynna',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO', 'NOT_APPLICABLE'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'ep-11--1',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 17900,
  sectionId: '2.2.4.1',
  impactArea: 'Recruitment, Hiring & Termination Practices',
  impactAreaId: 'RECRUITMENT_HIRING_AND_TERMINATION_PRACTICES',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
